export default __webpack_public_path__ + "static/media/iot_configuration_card.7c4b879c.jpg";